import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorView } from '@americanexpress/commercial-ux-components';

const AccessError = () => (
  <ErrorView
    heading={<FormattedMessage id="accessError.heading" />}
    details={
      <span data-testid="error-details">
        <FormattedMessage id="accessError.details" />
      </span>
    }
    actionButton={false}
  />
);

export default AccessError;
